import { Component, OnInit, OnDestroy, Input, KeyValueDiffers, DoCheck, Output, EventEmitter, ViewChild} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { FormattingService } from 'src/app/core/services/formatting.service';
import { ValueConsolidationType } from '../../enums/valueConsolidationType';
import { ResourceClassificationApiModel } from '../../models/resourceClassificationApiModel';
import { DxDataGridComponent } from 'devextreme-angular';
import { GraphSerieHelper } from '../../helpers/graph-serie.helper';

@Component({
    selector: 'app-graph-statistics',
    templateUrl: './graph-statistics.component.html',
    styleUrls: ['./graph-statistics.component.scss'],
    standalone: false
})
export class GraphStatisticsComponent implements OnInit, OnDestroy, DoCheck {
  private readonly unsubscribe: Subject<void> = new Subject();
  @Output() configurationChanged = new EventEmitter();
  @ViewChild("grid") chart: DxDataGridComponent;

  statisticsDataSource: any;
  differ: any;
  constructor(
    private readonly formattingService: FormattingService,
    private readonly translationService: TranslateService,
    private readonly differs:  KeyValueDiffers) {

    }
  @Input() resourceClassificationIdentifer: string;
  @Input() dataSource: any;
  @Input() series: any;
  @Input() argumentAxis: any;
  @Input() title: string;
  @Input() enumResourceClassificationMappings: any;
  @Input() canUpdateGraphSettings: boolean;
 
  ngDoCheck() {
    const argumentAxisChanges = this.differ['argumentAxis'].diff(this.argumentAxis);
    const seriesChanges = this.differ['series'].diff(this.series);
    if (argumentAxisChanges || seriesChanges) {
      this.computeStatisticsDataSource();
    }
  }

  ngOnInit() {
    this.differ = {};
    this.differ['argumentAxis'] = this.differs.find(this.argumentAxis).create();
    this.differ['series'] = this.differs.find(this.series).create();
  }

  computeStatisticsDataSource(){
    this.statisticsDataSource = [];
      this.series.forEach(serie => {
        const values = GraphSerieHelper.extractValues(serie, this.dataSource,this.argumentAxis);

        const serieMinValue = serie.resourceClassification.valueConsolidationType !== ValueConsolidationType.MaxDuration? 
        GraphSerieHelper.getMinValue(values):this.translationService.instant('Shell.generic.na');
        const serieMaxValue = serie.resourceClassification.valueConsolidationType !== ValueConsolidationType.MaxDuration? 
        GraphSerieHelper.getMaxValue(values):this.translationService.instant('Shell.generic.na');
        const serieAvgValue = serie.resourceClassification.valueConsolidationType !== ValueConsolidationType.MaxDuration? 
        GraphSerieHelper.getAverageValue(values):this.translationService.instant('Shell.generic.na');
        
        const serieColor = serie.color!==undefined? serie.color : '';
        this.statisticsDataSource.push({
          serieName: serie.name,
          color: serieColor,
          resourceClassification: serie.resourceClassification,
          min: serieMinValue,
          max: serieMaxValue,
          avg: serieAvgValue,
        });
      });
  }

  getFormattedValue(value: any, resourceClassification: ResourceClassificationApiModel) {
    return this.formattingService.getStatisticsFormattedValue( value,resourceClassification);
  }
  
  getSerieNameAndUnitSymbol(serieName: string){
    return serieName;
  }

  getStorageKey() {
      return `graphStatistics - ${this.resourceClassificationIdentifer ?? this.title}`;
  }

  onRowUpdated(event: any) {
    const serie = this.series.find(x => x.name === event.data.serieName);
    serie.color = event.data.color;

    this.configurationChanged.emit();
  }

  onColorCellValueChanged(cellInfo : any, color: any)
  {
    cellInfo.setValue(color);
    this.chart.instance.closeEditCell();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
